module.exports = __webpack_public_path__ + "img/5.24834d40.jpg";